import { render, staticRenderFns } from "./VAdvisor.vue?vue&type=template&id=3638ecb8"
import script from "./VAdvisor.vue?vue&type=script&lang=js"
export * from "./VAdvisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports